<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
<div class="container blog-item custom">
  <h1>
    VELI.STORE შენ რას ელი, ამ ახალ წელს?
  </h1>
  <h6>დეკემბერი 2022</h6>
  <br />

  <p>
    ონლაინ შოპინგი ერთგვარი თერაპიაა, რომელიც add to cart და checkout ფუნქციონალებს მიღმა, შენი კომფორტისთვის ათობით და
    ასობით ადამიანს აერთიანებს. დღეს veli.store-ზე, საქართველოში შექმნილ ელ.კომერციის კომპანიაზე, გიყვებით და მის
    საწყობში ვიზიტით მიღებულ შთაბეჭდილებებს გიზიარებთ. წარმოიდგინეთ ნამდვილი ელფების სამუშაო გარემო, სადაც კონკრეტული
    პიროვნების სურვილი წერილობითი სახით მიდის, მის დასამუშავებლად 14 კატეგორიას, ათასობით ბრენდს და ამდენივე პროდუქტს
    უნდა გადახედონ, კონკრეტული ნივთი შეარჩიონ და ელვის, ან უკვე „ველის“ სისწრაფით დაამუშაონ შეკვეთა. ღილაკზე თითის
    დაჭერიდან 2 საათში ან შენს მიერ შერჩეულ დროს ზღურბლთან მწვანე წებოვანი ლენტით საგულდაგულოდ შეფუთული ყუთი გაჩნდება,
    რომელშიც სწორედ ის ნივთია, რომელსაც ელი.
  </p>

  <img src="../../../../assets/blog/veli/img1.jpg" alt="" />
</div>

<div class="container-fluid m-0 p-0">
  <div class="full-color background-lime-green">
    <div class="container">
      <p class="quote">
        veli.store საყიდლების რუტინას ცვლის და ახალ კულტურას აყალიბებს. ციფრული პლატფორმა ინოვაციურ ტექნოლოგიურ
        გადაწყვეტებსა და სამომხმარებლო გამოცდილების დიზაინის პრინციპებს ეყრდნობა.
      </p>
    </div>
  </div>
</div>

<div class="container blog-item custom">
  <p>
    <i class="subhead capital">
      <b>როგორ ქმნის ველი მომხმარებლის საუკეთესო გამოცდილებას:</b>
    </i>
  </p>

  <p>
    კომპანიის ყველა ინიციატივა და აქტივობა დაფუძნებულია მომხმარებლისთვის ცხოვრების გამარტივებაზე, უმტკივნეულო და
    კომფორტული სერვისის შექმნისას, რაც ითარგმნება:
  </p>

  <p>
    <i class="subhead capital lime-green">
      <b>მარტივი და კომფორტული UX </b>
    </i>
  </p>

  <p>
    მომხმარებელი სულ რამდენიმე ღილაკის დაჭერით რეგისტრირდება პლატფორმაზე და ყიდულობს პროდუქტს. მას არ უწევს არასაჭირო
    ინფორმაციის შეყვანა. განმეორებითი შეძენა სხვადასხვა მისამართზე ძალიან მარტივია, რადგან მომხმარებელს შეუძლია
    სხვადასხვა მისამართის და ამავდროულად საკუთარი მონაცემების & საბანკო ბარათების დამახსოვრება.
  </p>

  <p>
    <i class="subhead capital lime-green">
      <b>მარტივი საძიებო სისტემა, რომელიც რამდენიმე წამს წაგართმევთ </b>
    </i>
  </p>

  <p>
    ყველა პროდუქტს სისტემაში გაწერილი აქვს სხვადასხვა საძიებო თაგი, რომლითაც მომხმარებელი შესაძლოა ეძებდეს სასურველ
    პროდუქტს. ამ მექანიზმის დახმარებით, Veli.store-ზე მომხმარებელი მარტივად პოულობს სასურველ ნივთს, ნებისმიერი მასთან
    დაკავშირებული სიტყვის ჩაწერისას.
  </p>

  <p>
    <i class="subhead capital lime-green">
      <b>სწრაფი და კომფორტული მიტანის სერვისი </b>
    </i>
  </p>

  <p>
    მომხმარებელი თავად ირჩევ დროის მონაკვეთს, რომელშიც სურს რომ მიიღოს შეკვეთა. მსგავსი ფუნქციონალი ინოვაციურია
    საქართველოს ბაზარზე. აღნიშნულის დახმარებით მომხმარებელს შესაძლებლობა აქვს კომფორტულად სასურველ დროს შეუკვეთოს
    პროდუქტი და არ იღელვოს იმაზე, იქნება თუ არა ადგილზე მაშინ, როდესაც კურიერი ამანათს მოიტანს.
  </p>

  <p>
    <i class="subhead capital lime-green">
      <b>მოტანის პროცესის გამჭვირვალობა </b>
    </i>
  </p>

  <p>
    შეკვეთის მომენტიდან შეკვეთის ჩაბარებამდე მომხმარებელი ყველა ეტაპზე იღებს SMS & email-ით ინფორმაციას მისი შეკვეთის
    სტატუსის შესახებ. ეს ნოტიფიკაციებია: შეკვეთის გაფორმება, შეკვეთა როდესაც მომხმარებლისკენ დაიძრა და, შეკვეთის
    ჩაბარების ნოთიფიკაცია.
  </p>

  <p>
    უფასო მიტანა მთელი საქართველოს მასშტაბით - რაც დამატებით კომფორტს ქმნის ყველა მომხმარებლისთვის.
  </p>

  <p>
    მარტივი და უმტკივნეულო დაბრუნების პროცესი - თუ პროდუქტი ის არ აღმოჩნდა, რასაც მომხმარებელი ელოდა, მას მარტივად
    შეუძლია დააბრუნოს პროდუქტი და დაიბრუნოს თანხა.
  </p>

  <p>
    <i class="subhead capital lime-green">
      <b>საჩუქრების შეფუთვა</b>
    </i>
  </p>

  <p>
    ველიზე ათასობით იდეალური საჩუქარი ნებისმიერი ასაკისა თუ ინტერესის ადამიანისთვის ერთ კატეგორიაში გააერთიანეს, რათა
    მათ შერჩევაზეც დაგეზოგათ დრო. შერჩეული ნივთის განსაკუთრებულ საჩუქრად გადაქცევა ღილაკებზე სულ რამდენიმე დაწკაპუნებით
    შეგიძლიათ. გადახდის გვერდზე, მონიშნავთ “შეფუთვა”, დაწერთ მისალოც ტექსტს და სულ ესაა. თქვენი ადრესატი საჩუქარს
    სასურველ დროს უკვე შეფუთულს, მისალოც ბარათთან ერთად, მიიღებს.
  </p>

  <img src="../../../../assets/blog/veli/img2.jpg" alt="" />

  <p>
    <i class="subhead capital">
      <b>ძლიერი საოპერაციო სისტემა, რომელიც შემდეგი ღერძებისგან შედგება: </b>
    </i>
  </p>

  <p>
    ყველა პროდუქტი, რომელსაც ველი ყიდის მოთავსებულია ველის დიდ საწყობში.
  </p>
  <p>
    საოპერაციო სოფტის დახმარებით, პროდუქტის აღებას და მომხმარებლისთვის გასაგზავნად მომზადებას სულ რაღაც 1 წუთი სჭირდება.
    საკუთარი საკურიერო სერვისი - რომელიც სხვადასხვა უბნებზე არის დანიშნული, რაც უზრუნველყოფს შენაძენის 3 საათში
    მომხმარებელთან მიწოდებას.
  </p>
  <p>
    მომხმარებელზე ფოკუსირებული გუნდი - კომპანიაში ყველა თანამშრომელი, განსაკუთრებით ისინი, ვისაც მომხმარებელთან
    პირდაპირი შეხება აქვთ გადიან ინტენსიურ გადასამზადებელ კურსებს კვარტალში ერთხელ. იმ გუნდებს, რომლებსაც მომხმარებელთან
    უშუალო შეხება აქვთ მუდმივად უტარდებათ პიროვნული უნარების ტრენინგებიც.
  </p>

  <img src="../../../../assets/blog/veli/img3.jpg" alt="" />

  <p>
    VELI.STORE-ში სჯერათ, რომ განსაკუთრებით ძვირფასს - დროს გაზოგინებენ, იმ დროს, რომელიც სადღესასწაულო საჩუქრის
    შესარჩევად გასულს საცობში, არჩევაში, ან სულაც რიგში უნდა დაგეხარჯა. გაითავისუფლე დრო და დახარჯე ის ახალი
    გამოცდილების მიღებაში - შენ რას ელი ამ ახალ წელს?
  </p>
</div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>VELI.STORE What are you expecting this New Year?</h1>
    <h6>December 2022</h6>
    <br />
  
    <p>
      Online shopping is a kind of therapy that, beyond the add to cart and checkout functions, brings together dozens and hundreds of people for your comfort. Today, I will tell you about veli.store, an e-commerce company created in Georgia, and share the impressions I got from visiting their warehouse. Imagine a real elf’s working environment, where a specific person's wish, written in the form of a request, must go through 14 categories, thousands of brands, and just as many products, from which they select a specific item and process the order with the speed of lightning or already the "Veli" speed. Within 2 hours from clicking the button or at the time you selected, a carefully packed box with green adhesive tape will appear on your doorstep, containing exactly the item you've been waiting for.
    </p>
  
    <img src="../../../../assets/blog/veli/img1.jpg" alt="" />
  </div>
  
  <div class="container-fluid m-0 p-0">
    <div class="full-color background-lime-green">
      <div class="container">
        <p class="quote">
          Veli.store is changing the shopping routine and shaping a new culture. The digital platform is based on innovative technological solutions and principles of user experience design.    
        </p>
      </div>
    </div>
  </div>
  
  <div class="container blog-item custom">
    <p>
      <i class="subhead capital">
        <b>How Veli creates the best experience for the customer:</b>
      </i>
    </p>
  
    <p>
      All of the company's initiatives and activities are based on simplifying life for the customer, creating a painless and comfortable service, which translates into:
    </p>
  
    <p>
      <i class="subhead capital lime-green">
        <b>Simple and Comfortable UX </b>
      </i>
    </p>
  
    <p>
      The user registers on the platform and buys products with just a few clicks. They do not need to enter unnecessary information. Repeated purchases to different addresses are very simple because users can save multiple addresses and simultaneously store their personal data and bank card information.
    </p>
  
    <p>
      <i class="subhead capital lime-green">
        <b>Simple search system, which will take you just a few seconds</b>
      </i>
    </p>
  
    <p>
      All products in the system are tagged with different search keywords, so the user can search for the desired product. With this mechanism, users on Veli.store can easily find the desired item by typing any word related to it.
    </p>
  
    <p>
      <i class="subhead capital lime-green">
        <b>Fast and Comfortable Delivery Service </b>
      </i>
    </p>
  
    <p>
      The user chooses the time slot in which they want to receive the order. This functionality is innovative in the Georgian market. Thanks to this, the user can conveniently order the product at their desired time and not worry about whether they will be at home when the courier delivers the package.
    </p>
  
    <p>
      <i class="subhead capital lime-green">
        <b>Transparency of the delivery process</b>
      </i>
    </p>
  
    <p>
      From the moment of the order to the delivery, the user receives updates on the status of the order via SMS and email. These notifications include: order confirmation, when the order is on its way to the user, and the delivery notification.
    </p>
  
    <p>
      Free delivery across Georgia - which adds extra comfort for all customers.
    </p>
  
    <p>
      Simple and Painless Return Process - If the product is not what the user expected, they can easily return it and get a refund.
    </p>
  
    <p>
      <i class="subhead capital lime-green">
        <b>Gift Wrapping</b>
      </i>
    </p>
  
    <p>
      Veli has gathered thousands of perfect gifts for people of any age or interest in one category to save time on selection. With just a few clicks, you can turn your selected item into a special gift. On the checkout page, you can select “Wrapping,” write a greeting message, and that’s it. Your recipient will receive the gift wrapped and with the greeting card at the desired time.
    </p>
  
    <img src="../../../../assets/blog/veli/img2.jpg" alt="" />
  
    <p>
      <i class="subhead capital">
        <b>A powerful operational system, which consists of the following pillars:</b>
      </i>
    </p>
  
    <p>
      All products that Veli sells are stored in Veli's large warehouse.
    </p>
    <p>
      With the help of operational software, it takes just 1 minute to pick the product and prepare it for shipping to the customer.
      Veli has its own courier service, which is assigned to different districts, ensuring that the purchase is delivered to the customer within 3 hours.
    </p>
    <p>Customer-focused team - Every employee in the company, especially those who have direct contact with customers, undergoes intensive retraining courses once every quarter. Teams that have direct contact with customers also regularly undergo personal skills training.
  
    <img src="../../../../assets/blog/veli/img3.jpg" alt="" />
  
    <p>
      VELI.STORE believes that they save the most precious thing — time, the time that would otherwise be spent in traffic jams, choosing a holiday gift, or even waiting in line. Free up your time and spend it gaining new experiences — what are you expecting this New Year?
    </p>
  </div>
  </ng-container>